<template>
    <div :class="['textarea-container', { disabled }]">
        <textarea
            :id="id"
            :disabled="disabled"
            :rows="rows"
            :value="modelValue"
            class="textarea-input"
            placeholder=" "
            @input="$emit('update:modelValue', $event.target.value)"
        ></textarea>
        <label :for="id" class="textarea-label">{{ label }}</label>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AreaText',
    props: {
        id: { type: String, required: true },
        label: { type: String, required: true },
        modelValue: { type: String, required: true },
        rows: { type: Number, default: 5 },
        disabled: { type: Boolean, default: false },
    },
});
</script>

<style scoped>
.textarea-container {
    position: relative;
    width: 100%;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    padding: 16px 12px 8px 12px;
    background-color: var(--white);
    transition: border-color 0.2s;
}

.textarea-input {
    width: 100%;
    min-height: 120px;
    max-height: 300px;
    overflow-y: auto;
    border: none;
    outline: none;
    background: transparent;
    font-family: 'Roboto', serif;
    color: var(--black);
    padding: 0;
    resize: vertical;
}

.textarea-input::placeholder {
    color: transparent;
}

/* Label flottant */
.textarea-label {
    position: absolute;
    left: 12px;
    top: 16px;
    font-family: 'Roboto';
    font-size: var(--font-size-low-medium);
    color: var(--medium-dark-grey);
    background-color: var(--white);
    padding: 0 4px;
    pointer-events: none;
    transition: 0.2s ease all;
}

.textarea-input:focus + .textarea-label,
.textarea-input:not(:placeholder-shown) + .textarea-label {
    top: -7px;
    font-size: var(--font-size-very-small);
    color: var(--medium-dark-grey);
}

.textarea-input:focus {
    border-color: var(--black);
}

.textarea-container.disabled,
.textarea-input:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
}

.textarea-container.disabled .textarea-label {
    color: var(--medium-dark-grey);
}
</style>
